import { useRef, useEffect } from 'react';

export default (fun) => {
  const ready = useRef(false);

  useEffect(() => {
    if (!ready.current) {
      ready.current = true;
      fun();
    }
  }, []);
};
